/*  MUI  */
import { Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/* Yarn */
import i18n from 'i18n';

/* React */
import React from 'react';

const { t } = i18n;

export const FilterTitle = ({ title }) => (
    <Typography variant="p" sx={{ fontSize: FontSizes[2], fontWeight: 600 }}>
        {t(title)}
    </Typography>
);
